module.exports = __webpack_public_path__ + "img/logo-light.c8b7ee2c.png";